/* ============================================================================
   LAH — RECEITA HERDADA NA RECOMPRA
   Tema: Testes de implementacao (0.4)

   Roda em todas as paginas, mas so age no carrinho.

   ============================================================================
   O QUE SAIU NESTE TEMA
   ============================================================================
   Os ATALHOS de recompra (pilha no cabecalho desktop e item no menu mobile)
   foram removidos a pedido, para nao interferir nos proximos testes.

   O BOTAO na pagina de produto CONTINUA, com todas as condicoes: cliente
   logado, pedido anterior com lente e receita vinculada.

   Este arquivo permaneceu porque ele faz a outra metade do trabalho — a que
   nao tem nada a ver com atalhos. Apaga-lo junto com os icones quebraria a
   heranca de receita, e a falha seria silenciosa: o pedido sairia sem os dados,
   sem erro nenhum na tela.

   ============================================================================
   POR QUE A RECEITA E APLICADA NO CARRINHO
   ============================================================================
   O painel de recompra guarda o pacote em sessionStorage e a gravacao acontece
   aqui, ja no carrinho: o configurador redireciona para la assim que adiciona,
   e tentar gravar atributos no meio desse caminho e corrida perdida.

   As chaves vem so com o SUFIXO (urlReceita, numeroDp, grauOD...). O prefixo e
   o ID da variante da armacao, que agora e outra — por isso sao remontadas com
   o ID atual, lido do proprio carrinho.

   Se qualquer parte falhar, a compra segue sem a receita herdada e o cliente
   informa depois na area de conta. Nunca travamos o pedido.
   ============================================================================ */

(function () {
    'use strict';

    var STORAGE_RX = 'lah_rx_pendente';
    var DEBUG = window.location.search.indexOf('lahdebug') !== -1;

    function log() {
        if (!DEBUG) return;
        try { console.log.apply(console, ['[lah-recompra]'].concat([].slice.call(arguments))); } catch (e) {}
    }

    if (window.location.pathname.indexOf('/cart') !== 0) return;

    function track(eventName, payload) {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(Object.assign({ event: eventName }, payload || {}));
        } catch (e) { /* analytics nunca deve quebrar a venda */ }
    }

    /* dataEnvio guarda quando a receita foi enviada NA COMPRA ANTERIOR.
       Copiada com o nome original, pareceria que o cliente acabou de enviar —
       e a idade da receita e o que a conferencia precisa saber. */
    var RENOMEAR = {
        dataEnvio: 'receitaDataOriginal'
    };

    function lerPendente() {
        try {
            var raw = window.sessionStorage.getItem(STORAGE_RX);
            return raw ? JSON.parse(raw) : null;
        } catch (e) {
            return null;
        }
    }

    function limparPendente() {
        try {
            window.sessionStorage.removeItem(STORAGE_RX);
        } catch (e) { /* ignora */ }
    }

    var pendente = lerPendente();
    if (!pendente || !pendente.sufixos || !pendente.sufixos.length) {
        log('nenhuma receita herdada pendente');
        return;
    }

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
            /* A armacao e o item marcado com custom pelo configurador */
            var armacao = null;
            for (var i = 0; i < cart.items.length; i++) {
                var props = cart.items[i].properties || {};
                if (props.custom) {
                    armacao = cart.items[i];
                    break;
                }
            }

            if (!armacao) {
                log('armacao nao encontrada no carrinho');
                limparPendente();
                return;
            }

            var atributos = {};
            pendente.sufixos.forEach(function (par) {
                var chave = RENOMEAR[par.chave] || par.chave;
                atributos[armacao.variant_id + '_' + chave] = par.valor;
            });

            /* Marca a origem: no atendimento, saber que a receita veio de um
               pedido anterior muda o que precisa ser conferido. */
            atributos[armacao.variant_id + '_receitaOrigem'] = pendente.origem || 'pedido anterior';

            return fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ attributes: atributos })
            });
        })
        .then(function () {
            track('lens_recompra_receita_aplicada', { origem: pendente.origem || '' });
            log('receita herdada aplicada');
            limparPendente();
        })
        .catch(function () {
            limparPendente();
        });
})();
